export default __webpack_public_path__ + "static/gitex_thumb-06b6bdb5e6d071ac6134cf4ff16e109c.png";